export default __webpack_public_path__ + "static/media/notify.aa79570d.mp3";